<div *ngIf="useServices" class="quality-notification">
    <notification [type]="mctNotification.type" *ngIf="mctNotification.active">
        <div *ngFor="let message of mctNotification.messageArray">
            {{message}}
        </div>
    </notification>
</div>
<div class="booking"
     [class.booking-selected]="selectedFlight"
     [class.wrap]="!inline"
     [class.inline]="inline"
     [class.lang-en]="languageService.userLanguage === 'en'">
    <div class="booking-part segment">
        <article class="flex-ctn segment-wrapper"
                 *ngFor="let segmentItemKey of bookingItem.segment | keys; let i = index;">
            <div class="flex-1">
                <div class="flex-ctn flex-6">
                    <ng-container *ngFor="let journeyItemKey of selectedJourneys; let x = index">
                        <segment class="flex-5"
                                 *ngIf="bookingItem.segment[segmentItemKey][journeyItemKey]"
                                 [segmentItemXId]="bookingItem.segment[segmentItemKey].xId"
                                 [isFareSentinel]="bookingItem.matchFareSentinel"
                                 [fareFamily]="bookingItem.fareFamily || null"
                                 [fareFamilyDictionary]="fareFamilyDictionary"
                                 [beginDaysDifference]="beginDaysDifference"
                                 [segmentItem]="bookingItem.segment[segmentItemKey][journeyItemKey]"
                                 [luggage]="bookingItem.luggage ? bookingItem.luggage.rule[ getLuggageIndex( bookingItem.segment[segmentItemKey].xId ) ]:null"
                                 [luggages]="getLuggages(bookingItem.segment[segmentItemKey].xId)"
                                 [carrier]="carrier"
                                 [inline]="isInlineSegment"
                                 [displayBan]="isLockSegment(x)"
                                 [showLogo]="true"></segment>
                    </ng-container>
                </div>

            </div>
            <div *ngIf="sectorData && showAllFlightDetails" class="flight-details">
                <flight-details *ngFor="let sector of sectorData[segmentItemKey]; let f= first"
                    [sector]="sector"
                    [showCloseBtn]="f"
                    (onClose)="showAllFlightDetails = false"></flight-details>
            </div>
        </article>
        <div class="btn-part">
            <ng-content select=".booking-additionnal-content-btn"></ng-content>
        </div>
    </div>
    <ng-container *permissionIf="'iqba.quote.rating.youcangoo.view'">
        <div class="rating-part e2e-best-rating-yucangoo" *ngIf="bookingItem.ratingArray | getYucangooRating: selectedJourneys">
            <yucangoo-rating [rating]="bookingItem.ratingArray | getYucangooRating: selectedJourneys"></yucangoo-rating>
        </div>
    </ng-container>
    <div class="booking-part propal-price-wrapper price" #priceWrapper
         [style.margin-left]="updatedPull ? updatedPull : 'auto'">
        <ng-container *ngIf="!hasPriceSwitcher">
            <div *permissionIf="permission.IQBA_BOOKING_PRICE_COST_SHOW" class="price-container e2e-quote-result-price-cost">
                <ng-container *ngIf="totalPrice.cost">
                    <strong class="big-price" [innerHTML]="totalPrice.cost | price:currency"></strong>
                    <div class="price-type">{{ labels.costTotal }}</div>
                </ng-container>
            </div>
            <div *permissionIf="permission.IQBA_BOOKING_PRICE_RETAIL_SHOW" class="price-container e2e-booking-price-retail">
                <ng-container *ngIf="totalPrice.retail">
                    <strong class="big-price" [innerHTML]="totalPrice.retail | price:currency"></strong>
                    <div class="price-type">{{ labels.retailTotal }}</div>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="hasPriceSwitcher">
            <div *ngIf="selectedPrice === priceTypes.cost" class="price-container e2e-quote-result-price-cost">
                <ng-container *ngIf="totalPrice.cost">
                    <strong class="big-price" [innerHTML]="totalPrice.cost | price:currency"></strong>
                    <div class="price-type">{{ labels.costTotal }}</div>
                </ng-container>
            </div>
            <div  *ngIf="selectedPrice === priceTypes.retail" class="price-container e2e-booking-price-retail">
                <ng-container *ngIf="totalPrice.retail">
                    <strong class="big-price" [innerHTML]="totalPrice.retail | price:currency"></strong>
                    <div class="price-type">{{ labels.retailTotal }}</div>
                </ng-container>
            </div>
        </ng-container>
        <p *permissionIf="permission.IQBA_FARETYPE_SHOW">{{ bookingItem.fareType }}</p>

        <div *ngIf="!(bookingItem.fareType | isFaretypePipe : fareTypes.public)">
            <div *ngIf="!displayLoading">
                <ng-container *ngIf="!showBestPrice">
                    <btn *permissionIf="'iqba.booking.price.getBestPublicPrice.use'"
                        click-stop
                        type="actionLink"
                        size="small"
                        classList="no-spacing"
                        (click)="setBestPrice()"
                        [label]="bestPriceLabels.default"></btn>
                </ng-container>

                <p *ngIf="showBestPrice">{{ bestPriceLabels.public }}</p>

                <div *permissionIf="'iqba.booking.price.cost.show'">
                    <ng-container *ngIf="bestPublicPriceValues">
                        <price-diff [values]="bestPublicPriceValues.cost"></price-diff>
                        <i>{{ labels.cost }}</i>
                    </ng-container>
                </div>

                <div *permissionIf="'iqba.booking.price.retail.show'">
                    <ng-container *ngIf="bestPublicPriceValues && bestPublicPriceValues.retail && hasRetailPrice">
                        <price-diff [values]="bestPublicPriceValues.retail"></price-diff>
                        <i>{{ labels.retail }}</i>
                    </ng-container>
                </div>

                <ng-content select=".my-custom-content"></ng-content>
            </div>

            <loader *ngIf="displayLoading" type="inline" [message]="bestPriceLabels.loading"></loader>

            <notification *ngIf="bestPriceError.active" [type]="bestPriceError.type">
                {{bestPriceError.message}}
            </notification>
        </div>

        <ng-container *permissionIf="permission.IQBA_HOSTCODE_SHOW">
            <div *ngIf="bookingItem.host">
                {{bookingItem.host | hostAlias | async}}
                <interface-flag [interface]="bookingItem.interface"></interface-flag>
            </div>
        </ng-container>
        <div class="carbon-footprint" *permissionIf="permission.SHARED_AIR_CARBON_FOOTPRINT_SHOW">
            <carbon-footprint
                    [carbonValue]="bookingItem.carbonFootprintArray | getDataForSelection: selectedJourneys"></carbon-footprint>
        </div>
        <div *ngIf="referenceValues" class="action-label">
            <p>{{ labels.reference }}</p>
            <price-diff [values]="referenceValues"></price-diff>
        </div>
        <ng-container *permissionIf="permission.SHARED_AIR_CANCEL_AND_EXCHANGE_PENALTY_SHOW">
            <div *ngIf="bookingItem.cancellation">
                <exchange [penaltyArray]="bookingItem.cancellation.rule"
                          [type]="penaltyTypes.cancellation"
                          [currency]="bookingItem.currency"></exchange>
            </div>
            <div *ngIf="bookingItem.exchange">
                <exchange [penaltyArray]="bookingItem.exchange.rule"
                          [type]="penaltyTypes.exchange"
                          [currency]="bookingItem.currency"></exchange>
            </div>
        </ng-container>

        <div *ngIf="selectSectorMatchFolder?.nbSameFlight" class="spaceTop">
            <label >
                {{labels.alreadyPresent}}
            </label>
            <div *ngFor="let total of selectSectorMatchFolder?.diffPrice">
                <div *ngIf="getPriceDif(total) as result">
                    <span [innerHTML]="total.value | price:currency"> </span>
                    <span [ngClass]="{'bestPrice':  !result.neg, 'worstPrice': result.neg}">
                        <span *ngIf="!result.neg"> - </span>
                        <span *ngIf="result.neg "> + </span>
                        <span [innerHTML]="result.value | price:currency"></span>
                    </span>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="booking-bottom-container">
    <ng-container *ngIf="showAllActions">
        <btn type="actionLink"
            click-stop
            size="small"
            classList="no-spacing"
            (click)="toggleDTPrice($event)"
            [label]="dtLabels.button">
            <fa-icon [icon]="showDTPrice ? iconAngleUp : iconAngleDown" class="icon-end"></fa-icon>
        </btn>

        <ng-container *permissionIf="'iqba.quote.rating.youcangoo.view'">
            <btn type="actionLink"
                click-stop
                size="small"
                classList="no-spacing"
                *ngIf="bookingItem.ratingArray | getYucangooRating: selectedJourneys"
                [label]="ratingDetailsLabel"
                (click)="toggleRatingDetails($event)">
                <fa-icon [icon]="showRatingDetails ? iconAngleUp : iconAngleDown" class="icon-end"></fa-icon>
            </btn>
        </ng-container>

        <btn type="actionLink"
            click-stop
            size="small"
            classList="no-spacing"
            (click)="textExport($event, selectedJourneys)"
            [label]="labels.exportText"></btn>
        <btn type="actionLink"
            click-stop
            size="small"
            classList="no-spacing"
            (click)="getAllFlightDetails($event, selectedJourneys)"
            [label]="flightDetailsLabels.button">
        </btn>
    </ng-container>

    <ng-content select=".booking-bottom"></ng-content>

</div>


<card class="dt-grid" *ngIf="showDTPrice" classList="clear-header">
    <div class="card-header-content">
        <label>
            {{labels.priceDetail}}
            <strong *ngIf="retailTitle">
                {{retailTitle}}
            </strong>
        </label>
        <menu-details [items]="priceNavigation" (onChangeTab)="onChangeTab($event); emitPriceType($event)"></menu-details>
    </div>

    <div class="card-body-content">
        <div>
            <i *ngIf="showBestPrice">{{ dtLabels.title }} :</i>
            <price-table [prices]="tablePrice"
                         [unlimitFirstColumnWidth]="true">
            </price-table>
        </div>
        <div *ngIf="showBestPrice">
            <i class="best-public-price-label">{{ bestPriceLabels.public }} :</i>
            <price-table [prices]="tableBestPrice"
                         [unlimitFirstColumnWidth]="true">
            </price-table>
        </div>
    </div>
</card>

<ng-container *permissionIf="permission.IQBA_QUOTE_RATING_YUCANGOO_VIEW">
    <div class="rating-grid"
         *ngIf="(bookingItem.ratingArray | getYucangooRating: selectedJourneys) && showRatingDetails">
        <rating-table [globalRating]="bookingItem.ratingArray | getYucangooRating: selectedJourneys"
                      [journeys]="journeys"
                      [airports]="airports"
                      [carriers]="carriers"></rating-table>
    </div>
</ng-container>
